import styled from 'styled-components'
import { RegularRow } from '../../utils/Grid'

export default styled(RegularRow)`
  margin: 0;
  text-align: center;
`
